import { render, staticRenderFns } from "./AccountingMenu.vue?vue&type=template&id=c3ab23dc&scoped=true"
import script from "./AccountingMenu.vue?vue&type=script&lang=js"
export * from "./AccountingMenu.vue?vue&type=script&lang=js"
import style0 from "./AccountingMenu.vue?vue&type=style&index=0&id=c3ab23dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ab23dc",
  null
  
)

export default component.exports